import { render, staticRenderFns } from "./ConsolidatedMembersTable.vue?vue&type=template&id=c0c13a16&scoped=true"
import script from "./ConsolidatedMembersTable.vue?vue&type=script&lang=js"
export * from "./ConsolidatedMembersTable.vue?vue&type=script&lang=js"
import style0 from "./ConsolidatedMembersTable.vue?vue&type=style&index=0&id=c0c13a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c13a16",
  null
  
)

export default component.exports